// extracted by mini-css-extract-plugin
export default {"layout":"_5DuskdCz","mobile-button":"_5D1AKdbb","desktop-button":"_5D2LjKxG","form-description":"_5D2wdITB"};